import api from "./client";

export async function getProfile() {
  const { data } = await api.get("/api/profile");
  return data.profile ?? data.data ?? data;
}

export async function updateProfile(payload) {
  const { data } = await api.put("/api/profile", payload);
  return data;
}

export async function getSkills() {
  const { data } = await api.get("/api/skills");
  return data.data ?? data;
}
export async function createSkill(payload) {
  const { data } = await api.post("/api/skills", payload);
  return data;
}
export async function updateSkill(id, payload) {
  const { data } = await api.put(`/api/skills/${id}`, payload);
  return data;
}
export async function deleteSkill(id) {
  await api.delete(`/api/skills/${id}`);
}

export async function getEducation() {
  const { data } = await api.get("/api/education");
  return data.data ?? data;
}
export async function createEducation(payload) {
  const { data } = await api.post("/api/education", payload);
  return data;
}
export async function updateEducation(id, payload) {
  const { data } = await api.put(`/api/education/${id}`, payload);
  return data;
}
export async function deleteEducation(id) {
  await api.delete(`/api/education/${id}`);
}

export async function getExperience() {
  const { data } = await api.get("/api/experience");
  return data.data ?? data;
}
export async function createExperience(payload) {
  const { data } = await api.post("/api/experience", payload);
  return data;
}
export async function updateExperience(id, payload) {
  const { data } = await api.put(`/api/experience/${id}`, payload);
  return data;
}
export async function deleteExperience(id) {
  await api.delete(`/api/experience/${id}`);
}
